import React, { createContext, useState, useEffect, useContext } from 'react';

const DeviceContext = createContext();

export const DeviceProvider = ({ children }) => {
  const [deviceCapabilities, setDeviceCapabilities] = useState({
    hasTouchSupport: false,
    hasCoarsePointer: false,
    hasFinePointer: false,
    isPortrait: window.innerHeight > window.innerWidth,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight
  });

  useEffect(() => {
    // Detect device capabilities
    const detectCapabilities = () => {
      const hasTouchSupport = 'ontouchstart' in window || 
                             navigator.maxTouchPoints > 0;
      
      const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
      const hasFinePointer = window.matchMedia('(pointer: fine)').matches;
      
      setDeviceCapabilities({
        hasTouchSupport,
        hasCoarsePointer,
        hasFinePointer,
        isPortrait: window.innerHeight > window.innerWidth,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight
      });
    };

    // Handle resize for orientation and viewport changes
    const handleResize = () => {
      setDeviceCapabilities(prev => ({
        ...prev,
        isPortrait: window.innerHeight > window.innerWidth,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight
      }));
    };

    // Initial detection
    detectCapabilities();
    
    // Set up resize listener
    window.addEventListener('resize', handleResize);
    
    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <DeviceContext.Provider value={deviceCapabilities}>
      {children}
    </DeviceContext.Provider>
  );
};

// Custom hook for easier access
export const useDevice = () => {
  const context = useContext(DeviceContext);
  if (context === undefined) {
    throw new Error('useDevice must be used within a DeviceProvider');
  }
  return context;
};
